<template>
  <label class="ui-checkbox">
    <input
      :checked="value"
      :disabled="disabled"
      autocomplete="off"
      class="ui-checkbox-element"
      type="checkbox"
      @change.prevent="handleChange">
    <span
      :class="{
        'ui-checkbox-box--active' : value,
        'ui-checkbox-box--disabled' : disabled,
      }"
      class="ui-checkbox-box">
      <span
        class="shape-check"
        :class="{ 'shape-check--hidden': !value }" />
    </span>
    <slot />
  </label>
</template>

<script>
export default {
  name: 'UiCheckbox',

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleChange(e) {
      this.$emit('input', e.target.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
  .ui-checkbox {
    --size: 22px;
    --check-size: 13px;
    --check-color: white;
    --bg-color: #{$color--basic-superdark-gray};
    --bg-color-checked: #{$color--basic-blue};
    --border-radius: 2px;
    --border: none;
    --font-size: 1em;
    --font-weight: 500;

    display: flex;
    cursor: pointer;
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    align-items: center;
    user-select: none;
  }

  .ui-checkbox-element {
    display: none;
  }

  .shape-check {
    --shape-color: var(--check-color);

    width: var(--check-size);
  }

  .ui-checkbox-box {
    height: var(--size);
    width: var(--size);
    background: var(--bg-color);
    border: var(--border);
    border-radius: var(--border-radius);
    margin-right: 12px;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    transition: background-color 0.15s ease-out;
  }

  .ui-checkbox-box--active{
    background: var(--bg-color-checked);
  }

  .ui-checkbox-box--disabled {
    opacity: .4;
    cursor: not-allowed;
  }
</style>
